import { useEffect, useState } from "react";
import { validatePromocode } from "../services/validatePromocode";

export const useCheckout = (initialData = {}) => {
  const email=localStorage.getItem("email");
  const promoFromAPI =
    initialData?.promoCode ||
    initialData?.questionDetails?.promoCode ||
    "";



  const [data, setData] = useState({
    price: initialData?.questionDetails?.estimatedPrice || 0,
    promoCode: promoFromAPI,
    discount:initialData?.questionDetails?.promoPrice || 0,
    questionId: initialData?.questionDetails?._id,
    paymentSection: initialData?.questionDetails?.paymentSection,
    paymentMethod: initialData?.paymentMethod,

    billing: {
      name: "",
      address: "",
      city: "",
      state: "",
      postalCode: "",
    },
    payment: {
      email:email || '',
      cardNumber: "",
      expiryDate: "",
      securityCode: "",
    },
  });

  const [promoState, setPromoState] = useState({
    loading: false,
    success: null,
    message: "",
  });

  const isPromoLocked = !!promoFromAPI;

   const total = Math.max((data.price || 0) - (data.discount || 0), 0);
  const applyPromo = async (code = data.promoCode) => {
    if (!code) return;

    setPromoState({ loading: true, success: null, message: "" });

    try {
      const res = await validatePromocode({
        questionId: initialData?.questionDetails?._id,
        promoCode: code,
        paymentSection: initialData?.questionDetails?.paymentSection,
      });
      setPromoState({
        loading: false,
        success: res?.isSuccess,
        message: res?.message,
      });

      if (res?.isSuccess) {
        setData((prev) => ({
          ...prev,
          promoCode: code,
          discount: res?.promoPrice || 0,
        }));
      }
    } catch(error) {
      setPromoState({
        loading: false,
        success: false,
        message: "Something went wrong",
      });
    }
  };
  useEffect(() => {
    if (promoFromAPI) {
      applyPromo(promoFromAPI);
    }
  }, []);

  return {
    data,
    setData,
    total,
    promoState,
    applyPromo,
    isPromoLocked,
  };
};